import React from "react";
import { getStatusColor } from "../../utils/budgetingUtils";

interface StatusBadgeProps {
  status: string | undefined;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  // If status is empty or undefined, don't render anything
  if (!status) return null;
  
  const color = getStatusColor(status);
  
  return (
    <span
      className="px-2 py-1 rounded-full text-sm text-white"
      style={{ backgroundColor: color }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;